(async function(algolia) {
    'use strict';
    
    // Initialize persitent and authenticated user tokens
    window.aa('init',{
      partial:true,
      appId: algolia.config.app_id,
      apiKey: algolia.config.search_api_key,
      useCookie:true // enables persistent userTokens
    })
    /**
     * Saves details in local storage for conversion tracking
     */
    algolia.saveForConversionTracking = function (data) {
      //add user token to data
      let userToken = null;
      window.aa('getUserToken', null, (err, currentUserToken) => {
        if (err) {
          console.error(err);
          return;
        }
        userToken = currentUserToken;
      });
      let authenticatedUserToken;
      window.aa('getAuthenticatedUserToken', null, (err, currentUserToken) => {
        if (err) {
          console.error(err);
          return;
        }
        authenticatedUserToken = currentUserToken;
      });
      data.userToken = userToken;
      data.authenticatedUserToken = authenticatedUserToken;

      window.dataLayer.push( data );
      /**
       * We're using a try, catch here to handle any possible exceptions
       * resulting from local storage or JSON parsing.
       */
      const localStorageKey = 'algolia_analytics_clicked_objects'
      try {
        // Get any data previously stored
        const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
        const previousClickItems = JSON.parse(previousClickItemsString);  
        // Add the current products data to local storage
        previousClickItems.push(data)
        localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
        //store persistent userToken in local storage algolia config 
        algolia.config.user_token = userToken;
        const CONFIG_STORAGE_KEY = 'algolia_config';
        localStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(algolia.config))
        window.dataLayer.push( data );
      } catch (error) {
        console.error(error);
        // No need to do anything in this scenario
      }
    };
    //create the click data object
    algolia.getClickData = function(hit){
      const clickData = {
        index: hit.index,
        eventName: 'Hit Clicked',
        queryID: hit.queryID,
        objectIDs: [hit.objectID],
        productId: `${hit.id}`,
      };
      return clickData;
    }
    //save click data for conversion tracking
    algolia.saveClickData = function(hit){
      algolia.saveForConversionTracking(algolia.getClickData(hit))
    };
    //manually send events to Algolia
    algolia.customSendEvent = function(hit){
      const clickData = algolia.getClickData(hit);
      clickData.eventName = 'Item Clicked';
      clickData.positions = hit.itemPosition ? [hit.itemPosition] : [hit.position];
      window.aa('clickedObjectIDsAfterSearch', clickData);  
    }
  })(window.algoliaShopify);